import { createRouter, createWebHistory } from 'vue-router'
import storage, { TOKEN_INFO } from '@shared/utils/storage'
import useAppStore from '@shared/store/useAppStore'
import { initConfig } from '@shared/config/sysConfig.js'
/** 基础路由 */
const routes = [
  {
    path: '/',
    redirect: '/work'
  },
  {
    path: '/login',
    component: () => import('@shared/views/login/index.vue'),
    meta: { hidden: true }
  },
  {
    path: '/403',
    component: () => import('@shared/views/40x/403.vue'),
    meta: { hidden: true }
  },
  {
    path: '/micro-app/:anyPath*',
    component: () => import('@shared/layout/MainApp.vue'),
    meta: { hidden: true }
  },
  {
    path: '/iframe-app',
    component: () => import('@shared/layout/IframeApp.vue'),
    meta: { hidden: true }
  },
  {
    path: '/downloadAPK',
    component: () => import('@/views/downloadAPK/index.vue'),
    meta: { hidden: true }
  },
  {
    path: '/config-settings',
    component: () => import('@shared/views/config-settings/index.vue'),
    meta: { hidden: true, alwaysShow: true }
  },
  {
    path: '/:matchOthers(.*)*',
    component: () => import('@shared/views/40x/403.vue'),
    meta: { hidden: true }
  }
]

const basepath = process.env.npm_config_basepath || import.meta.env.VITE_BASE_PATH

const router = createRouter({
  history: createWebHistory(basepath),
  routes
})

let routeFlag = false
router.beforeEach(async (to, from, next) => {
  const appStore = useAppStore()
  //TODO: (!!重要!!) 动态设置basepath导致不好存router实例，先存这里了。
  if (!appStore.router) appStore.router = router
  // 进来先去获取项目配置
  if (!window.__SYS_CONFIG) {
    await appStore.getProjectConfig()
    initConfig()
  }
  const tokenValue = storage.getItem('tokenValue', TOKEN_INFO)
  if (tokenValue) {
    // 如果没有注册动态路由，则注册动态路由
    if (routeFlag) {
      next()
    } else {
      // 注册动态路由
      await appStore.setUserInfo()
      await appStore.getOssUrl()

      routeFlag = true
      next({ ...to, replace: true })
    }
  } else {
    // 判断是否为权限页面，是就跳转到登录页
    if (['/login', '/downloadAPK'].includes(to.path)) {
      next()
    } else {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  }
})

router.afterEach((to) => {
  if (to.meta.systemName) {
    // 路由跳转完成后，需激活当前路由
    const appStore = useAppStore()
    appStore.activeSystem = to.meta.systemName
  }
})

export default router
